import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  disabled,
  ...props
}) => {
  const baseClasses = 'font-semibold rounded-lg transition-all flex items-center justify-center gap-2 border focus:outline-none focus:ring-2 focus:ring-offset-2';
  
  const variants = {
    primary: 'bg-blue-500 hover:bg-blue-600 text-white disabled:bg-blue-300 shadow-sm border-blue-500 focus:ring-blue-500',
    secondary: 'bg-gray-500 hover:bg-gray-600 text-white disabled:bg-gray-300 shadow-sm border-gray-500 focus:ring-gray-500',
    success: 'bg-green-500 hover:bg-green-600 text-white disabled:bg-green-300 shadow-sm border-green-500 focus:ring-green-500',
    danger: 'bg-red-500 hover:bg-red-600 text-white disabled:bg-red-300 shadow-sm border-red-500 focus:ring-red-500',
    ghost: 'bg-transparent hover:bg-gray-100 text-gray-700 border-gray-300 hover:border-gray-400 focus:ring-gray-500'
  };
  
  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg'
  };

  return (
    <button
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${
        disabled ? 'cursor-not-allowed opacity-50' : 'hover:-translate-y-0.5'
      } ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};